import { pawnshop_reports_settings_service } from "../../../api/restclient";

export const getAreaTargetsCollection = (data) => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.get(
      "/settings/areaTargets",
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const getSingleAreaTargets = (data) => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.get(
      `/settings/areaTargets${data.id}`,
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const addAreaTargets = (data) => {
  try {
    var urlParams = new URLSearchParams();
    urlParams.append("areaCode", data.areaCode);
    urlParams.append("month", data.month);
    urlParams.append("year", data.year);
    urlParams.append("value", data.value);
    return pawnshop_reports_settings_service.post(
      `/settings/areaTargets?${urlParams}`
    );
  } catch {
    return Promise.resolve();
  }
};

export const deleteAreaTargets = (data) => {
  try {
    const params = {};
    return pawnshop_reports_settings_service.delete(
      `/settings/areaTargets/${data.id}`,
      params
    );
  } catch {
    return Promise.resolve();
  }
};

export const updateAreaTargets = (data) => {
  try {
    var urlParams = new URLSearchParams();
    urlParams.append("areaCode", data.areaCode);
    urlParams.append("month", data.month);
    urlParams.append("year", data.year);
    urlParams.append("value", data.value);
    return pawnshop_reports_settings_service.put(
      `/settings/areaTargets/${data.id}?${urlParams.toString()}`
    );
  } catch {
    return Promise.resolve();
  }
};
